import * as React from "react";
import {ReactNode, useEffect, useState} from "react";
import {IProfile, PurposeType} from "StateInterface";
import {ConsentBox} from "consent/utils/consentBox";
import TextField from "consent/utils/textField";
import {getRequestExternal} from "utils/externalApiCalls";
import Button, {SIZE} from "myshubhlife-component/button";
import {regex} from "profile/regex";
import {FIELD_NAMES} from "profile/enums";
import {partnerOfferings} from "login/config";

interface IProps {
    profile: IProfile;
    onComplete: (profile) => void;
    purposeType: PurposeType;
    utm_source?: string;
}

export const renderbankDetails = (bankDetails): ReactNode => {
    return Object.keys(bankDetails).map((key) => {
        return (
            <div style={{display: "flex", marginBottom: 1}} key={key}>
                <div style={{fontWeight: 900, width: 50}}>
                    {key.toUpperCase() + ":"}
                </div>
                <div>
                    {bankDetails[key]}
                </div>
            </div>
        );
    });
};

const IFSC_CODE_LENGTH = 11;
export const BankAccountDetails = (props: IProps) => {
    const [bankAccountNumber, updateBankAccountNumber] = useState("");
    const [reBankAccountNumber, updateReBankAccountNumber] = useState("");
    const [ifscCode, updateIfscCode] = useState("");
    const [bankDetails, updateBankDetails] = useState(null);
    const [reAccountErrorMessage, updateReAccountErrorMessage] = useState("");
    const [ifscCodeErrorMessage, updateIfscCodeErrorMessage] = useState("");
    const [accountErrorMessage, updateAccountErrorMessage] = useState("");
    useEffect( () => {
        if ( props.profile &&  props.profile.bankAccounts && props.profile.bankAccounts.length > 0) {
            const bankAccount = props.profile.bankAccounts;
            const {accountNumber, ifsc, purposeType} = bankAccount[bankAccount.length - 1];
            if (purposeType === PurposeType.NACH) {
                if (accountNumber) {
                    updateBankAccountNumber(accountNumber ? accountNumber : "");
                    updateReBankAccountNumber(accountNumber ? accountNumber : "");
                }
                if (ifsc) {
                    updateIfscCode(ifsc);
                    updateAndCheckIfscCode(ifsc);
                }
            }
        }
    }, []);
    const updateAndCheckAccountNumber = (accountNumber: string) => {
        updateBankAccountNumber(accountNumber);
        if (accountNumber.length > 0 && reBankAccountNumber.length > 0 && accountNumber !== reBankAccountNumber) {
            updateReAccountErrorMessage("Account Number does not match");
        } else {
            updateReAccountErrorMessage("");
        }
    };
    const updateAndCheckReBankAccountNumber = (reAccountNumber: string) => {
        updateReBankAccountNumber(reAccountNumber);
        if (bankAccountNumber.length > 0 && reAccountNumber.length > 0 && bankAccountNumber !== reAccountNumber) {
            updateReAccountErrorMessage("Account Number does not match");
        } else {
            updateReAccountErrorMessage("");
        }
    };

    const updateAndCheckIfscCode = (ifsc: string) => {
        updateIfscCode(ifsc);
        if (ifsc.length === IFSC_CODE_LENGTH) {
            const ifscDetails = getRequestExternal(`https://ifsc.razorpay.com/${ifsc}`, null);
            ifscDetails.then((response: any) => {
                const resBankDetails = JSON.parse(response);
                updateBankDetails({
                    bank: resBankDetails.BANK,
                    city: resBankDetails.CITY,
                    state: resBankDetails.STATE,
                    branch: resBankDetails.BRANCH,
                });
                updateIfscCodeErrorMessage("");
            });
            ifscDetails.catch((err) => {
                updateIfscCodeErrorMessage(err.status === 404 ? "Incorrect IFSC code!" : "Something went wrong!");
                updateBankDetails(null);
            });
        } else if (ifsc.length > 0) {
            updateIfscCodeErrorMessage("Incorrect IFSC code!");
            updateBankDetails(null);
        } else {
            updateIfscCodeErrorMessage("");
        }
    };
    const handleProceed = () => {
        if(!new RegExp(regex[FIELD_NAMES.ACCOUNT_NUMBER]).test(bankAccountNumber)) {
            updateAccountErrorMessage("Please enter correct account number");
            return;
        } 
        props.onComplete({
            bankAccount: {
                accountNumber: bankAccountNumber,
                ifsc: ifscCode,
                bankName: bankDetails.bank,
                purposeType: props.purposeType
            }
        });
    };

    return (
        <ConsentBox pageTitle="Bank Account Details">
            <TextField
                type={"text"}
                label="Account Number"
                placeholder={"Please enter account number"}
                value={bankAccountNumber}
                fieldName={"bankAccountNumber"}
                onChange={(value) => updateAndCheckAccountNumber(value)}
                errorMsg = {accountErrorMessage}
            />
            <div style={{marginTop: 27}}>
                <TextField
                    type={"text"}
                    label="Re-Enter Account Number"
                    placeholder={"Please re-enter account number"}
                    value={reBankAccountNumber}
                    fieldName={"reBankAccountNumber"}
                    onChange={(value) => updateAndCheckReBankAccountNumber(value)}
                    errorMsg={reAccountErrorMessage}
                />
            </div>
            <div style={{marginTop: 27}}>
                <TextField
                    type={"text"}
                    label="IFSC Code"
                    placeholder={"Please enter IFSC code"}
                    value={ifscCode}
                    fieldName={"ifsc"}
                    onChange={(value) => updateAndCheckIfscCode(value.toUpperCase())}
                    errorMsg={ifscCodeErrorMessage}
                />
            </div>
            <div className="flex-column-center-row" style={{fontSize: 10, color: "#434175", minHeight: 70}}>
                {bankDetails ? <div>
                    {renderbankDetails(bankDetails)}
                </div> : null}
            </div>
            <div className="flex-center-row">
                <Button
                    buttonText="Continue"
                    isDisabled={
                        bankAccountNumber.length === 0 ||
                        reBankAccountNumber.length === 0 ||
                        ifscCode.length === 0 ||
                        reAccountErrorMessage.length > 0 ||
                        ifscCodeErrorMessage.length > 0
                    }
                    size={SIZE.LARGE}
                    rounded={true}
                    onClick={() => handleProceed()}
                    bgColor={partnerOfferings[props.utm_source]?.colors?.green}
                />
            </div>
        </ConsentBox>
    );
};

export default BankAccountDetails;
